'use strict';
import $ from 'jquery';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export default class CarouselModule {
    static init() {
        $('.module-carousel').each((index, el) => {
            new CarouselModule($(el));
        });
    }

    constructor($el) {
        this.el = $el;
        this.initSwiper();
        this.el.find('.module-carousel-tabs a').on('click', this.onTabClick.bind(this));
        this.el.find('.swiper-slide').on('click', this.onSlideClick.bind(this));
    }

    initSwiper() {
        const self = this;
        this.mainSwiper = new Swiper('#' + this.el.find('.module-carousel-main-swiper').attr('id'), {
            modules: [Pagination],
            slidesPerView: 1.1,
            centeredSlides: true,
            spaceBetween: 16,
            grabCursor: true,
            keyboard: { enabled: true },
            a11y: { enabled: true },
            pagination: {
                el: self.el.find('.module-carousel-pagination').get(0),
                type: 'bullets',
                clickable: true,
            },
            breakpoints: {
                576: { spaceBetween: 16 },  // sm
                768: { slidesPerview: 1, spaceBetween: 20 },  // md
                992: { slidesPerView: 1.5 },  // lg
            },
            on: {
                activeIndexChange: (swiper) => {
                    self.el.find('.module-carousel-tabs a.primary-cta').removeClass('primary-cta').addClass('secondary-cta');
                    self.el.find('.module-carousel-tabs a:nth-child(' + (swiper.activeIndex + 1) + ')').removeClass('secondary-cta').addClass('primary-cta');
                }
            },
        });
    }

    onTabClick(e) {
        e.preventDefault();
        const target = $(e.currentTarget);
        const slide = target.data('slide');
        this.mainSwiper.slideTo(slide);
    }

    onSlideClick(e) {
        console.log("clicked: ", $(e.currentTarget));
        const $a = $(e.currentTarget).find('a');
        if ($a.length) {
            if ($a.target !== '') {
                window.open($a.attr('href'), '_blank');
            } else {
                window.document.location = $a.attr('href');
            }
        }
    }
}